export default {
  green: '#46ae70',
  blue: '#00aeff',
  darkgray: '#282828',
  moregray: '#f7f7f7',
  gray: '#727272',
  lightgray: '#d7d7d7',
  lightblue: '#44ADF8',
};
